import React, { useState, useEffect } from "react";
import { useSelector } from 'react-redux';
import { Container, Wave } from "./Styled";
import { Button } from 'antd';
import { CaretRightOutlined, PauseOutlined } from '@ant-design/icons';
import Loader from "../../../system/loader/Loader";
import WaveSurfer from "wavesurfer.js";
// @ts-ignore
import RegionsPlugin from "wavesurfer.js/dist/plugin/wavesurfer.regions.js";
import { RootState } from "../../../../model/rootReducer";

type AudioPlayerProps = {
  isLoading: boolean;
  url: string;
  onPlayPause: () => void;
  className?: string;
  isPlaying: boolean;
  setWave: (waveSurfer: WaveSurfer) => void;
};

export const AudioPlayer: React.FunctionComponent<AudioPlayerProps> = ({ className, isLoading, onPlayPause, isPlaying, setWave }) => {
  const [hasAudio, setHasAudio] = useState(false)
  const bearer = useSelector((state: RootState) => state.app.bearer)

  useEffect(() => {
    console.log("set waveForm");
    var wave = WaveSurfer.create({
      xhr: {requestHeaders: [{
        key: "Authorization",
        value: "Bearer " + bearer
      }]},
      barWidth: 4,
      cursorWidth: 1,
      container: "#waveform",
      backend: "WebAudio",
      height: 150,
      progressColor: "#1890ff",
      responsive: true,
      waveColor: "#EFEFEF",
      cursorColor: "transparent",
      barRadius: 3,
      plugins: [
        RegionsPlugin.create({})
      ]})
      wave.on('ready', () => {
        setHasAudio(true)
    })
    setWave(wave);
    return () => {
      
    }
  }, [])
  
  return (
    <Loader isLoading={isLoading}>
      <Container className={className}>
        {hasAudio && 
         <Button disabled={!hasAudio} type="primary" onClick={onPlayPause} shape="circle" icon={isPlaying ? <PauseOutlined />
          : <CaretRightOutlined />} />
        }
        <Wave id="waveform" />
        <audio id="track" />
      </Container>
    </Loader>
  );
};

export default AudioPlayer;